import React from "react";


import HeadingSecondary from "../components/ HeadingSecondary";
import FaqBox from "../components/FaqBox";
import faqs from "../assets/faq/faq.json";


const SettingFAQ: React.FC<any> = () => {
  return (
    <div className="setting">
      <div className="u-margin-top-medium u-margin-bottom-small-2">
        <HeadingSecondary text="سوالات متداول"/>
      </div>

      <div className="setting__faq u-margin-bottom-big">
        <section
          className=""
          id="faq-section"
        >
          <div className="">
            {faqs.fa.map((item, index) => {
              return <FaqBox answer={item.answer} question={item.question} key={index} classNames={'u-box-shadow u-width-100 u-margin-bottom-small-1'}/>;
            })}
          </div>
        </section>
      </div>
    </div>
  );
}

export default SettingFAQ;